import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import qq from 'node_modules/fine-uploader/fine-uploader/fine-uploader.min.js'
import {TextItem} from "../../editor/text-item/text-item";

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html'
})
export class FileUploadComponent implements OnInit, AfterViewInit {
    @Input() endpointPath: string;
    @Input() selectorId: string;
    @Input() allowedExtensions: string;
    @Input() itemLimit: number;
    @Input() sizeLimit: number;
    @Output() onAllCompleteEvent  =  new EventEmitter<any>();
    @Output() onCompleteEvent     =  new EventEmitter<any>();

    fileUploaderInstance:any;

    constructor() { }

    ngOnInit() {

    }


    ngAfterViewInit() {
      let settings = {
          element: document.getElementById(this.selectorId),
          template: 'qq-template-gallery',
          request: {
              endpoint: this.endpointPath
          },
          thumbnails: {
              placeholders: {
                  waitingPath: '/assets/file-upload/waiting-generic.png',
                  notAvailablePath: '/assets/file-upload/not_available-generic.png'
              }
          },
          validation: {
              allowedExtensions: this.allowedExtensions ? this.allowedExtensions.split(',') : null,
              itemLimit: this.itemLimit,
              sizeLimit: this.sizeLimit * 1024 // 50 kB = 50 * 1024 bytes
          },
          autoUpload: false,
          debug: false,
          callbacks: {
              onAllComplete: ( succeeded, failed ) => {
                  console.log( 'Fired: onAllComplete', succeeded, failed );
                  this.onAllCompleteEvent.emit({
                      succeeded : succeeded,
                      failed : failed
                  });
              },
              onComplete: ( id, name, params ) => {
                  console.log( 'Fired: onComplete', id, name, params );
                  this.onCompleteEvent.emit({
                      id: id,
                      name: name,
                      params: params
                  });
              }
          }
      };

     this.fileUploaderInstance = new qq.FineUploader(settings);
    }

    upload() {
        this.fileUploaderInstance.uploadStoredFiles();
    }

}
